// src/hooks/useAuthApi.js
import useApi from "./useApi";

/**
 * Custom hook for authentication-related API calls
 */
export const useAuthApi = () => {
  const { api, loading, error, data } = useApi({
    showToast: true,
  });

  /**
   * User registration
   * @param {Object} userData - User registration data
   */
  const register = async (userData) => {
    return await api.post("/auth/v1/signup", userData, {
      showToast: true,
    });
  };

  /**
   * User login
   * @param {Object} credentials - Login credentials
   */
  const login = async (credentials) => {
    return await api.post("/auth/v1/login", credentials, {
      showToast: true,
    });
  };

  /**
   * Send OTP for Login
   * @param {Object} data - { phone: "..." }
   */
  const sendLoginOtp = async (data) => {
    return await api.post("/auth/v1/login/otp/send", data, {
      showToast: true,
    });
  };

  /**
   * Login with OTP
   * @param {Object} data - { phone: "...", otp: "..." }
   */
  const loginWithOtp = async (data) => {
    return await api.post("/auth/v1/login/otp", data, {
      showToast: true,
    });
  };

  /**
   * Verify email
   * @param {string} token - Verification token
   */
  const verifyEmail = async (token) => {
    return await api.post(
      "/auth/verify-email",
      { token },
      {
        showToast: true,
      }
    );
  };

  /**
   * Forgot password (Email or Phone)
   * @param {Object} data - { email: "..." } or { phone: "..." }
   */
  const forgotPassword = async (data) => {
    return await api.post(
      "/auth/v1/forgot-password",
      data,
      {
        showToast: true,
      }
    );
  };

  /**
   * Reset password
   * @param {Object} resetData - { email/phone, otp, new_password, confirm_password }
   */
  const resetPassword = async (resetData) => {
    return await api.post("/auth/v1/reset-password", resetData, {
      showToast: true,
    });
  };

  return {
    register,
    login,
    sendLoginOtp,
    loginWithOtp,
    verifyEmail,
    forgotPassword,
    resetPassword,
    loading,
    error,
    data,
  };
};

export default useAuthApi;
